import React, { useState, useEffect, useMemo } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import "../styles/home.scss";
import { backend } from '../../../components/apipath';

function Newsarea() {
    const [newsData, setNewsData] = useState({});
    const [currentPage, setCurrentPage] = useState(1);
    const [categories, setCategories] = useState([]);
    const [currentImageId, setCurrentImageId] = useState(0);
    const cardsPerPage = 6;

    useEffect(() => {
        fetchCategories();
    }, []);

    const fetchCategories = async () => {
        try {
            const res = await axios.get(`${backend}home/newsCategories`);
            setCategories(res.data || []);
            if (res.data && res.data.length > 0) {
                newsButtonClick(res.data[0].art_type);
            }
        } catch (err) {
            console.error("Error fetching categories:", err);
        }
    };

    const newsButtonClick = async (categoryId) => {
        try {
            const res = await axios.get(`${backend}home/newsselect/${categoryId}`);
            setNewsData(res.data || {});
            setCurrentPage(1);
            setCurrentImageId(categoryId);
        } catch (err) {
            console.error("Error fetching news:", err);
        }
    };

    // 扁平化所有新聞，方便分頁與統計
    const flatNews = useMemo(() => Object.values(newsData).flat(), [newsData]);

    const totalPages = useMemo(
        () => Math.ceil((flatNews?.length || 0) / cardsPerPage),
        [flatNews, cardsPerPage]
    );

    const getPageNumbersToShow = () => {
        const maxPageNumbersToShow = 10;
        const middlePage = currentPage;
        const half = Math.floor(maxPageNumbersToShow / 2);

        let startPage = middlePage - half;
        let endPage = middlePage + half;

        if (startPage <= 0) {
            startPage = 1;
            endPage = Math.min(totalPages, maxPageNumbersToShow);
        }
        if (endPage > totalPages) {
            endPage = totalPages;
            startPage = Math.max(1, totalPages - maxPageNumbersToShow + 1);
        }
        if (totalPages === 0) return [];
        return Array.from({ length: endPage - startPage + 1 }, (_, i) => startPage + i);
    };

    const startIndex = (currentPage - 1) * cardsPerPage;
    const endIndex = startIndex + cardsPerPage;
    const currentNews = flatNews.slice(startIndex, endIndex);

    const formatDate = (dateStr) => {
        if (!dateStr) return "";
        const d = new Date(dateStr);
        if (isNaN(d.getTime())) return "";
        // 轉成 YYYY.MM.DD
        const yyyy = d.getFullYear();
        const mm = String(d.getMonth() + 1).padStart(2, "0");
        const dd = String(d.getDate()).padStart(2, "0");
        return `${yyyy}.${mm}.${dd}`;
    };

    useEffect(() => {
        const active = document.querySelector('.newtab .nav-link.active');
        active?.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
      }, [currentImageId]);
      
    return (
        <div className="container">
            <div className="row">
                <div className="newtitle">最新消息</div>

                {/* 分類 tab */}
                <ul className="nav nav-tabs newtab" role="tablist" aria-label="News categories">
                {categories.map((category) => (
                    <li className="nav-item" role="presentation" key={category.art_type}>
                    <button
                        className={`nav-link ${currentImageId === category.art_type ? "active" : ""}`}
                        type="button"
                        role="tab"
                        aria-selected={currentImageId === category.art_type}
                        onClick={() => newsButtonClick(category.art_type)}
                    >
                        {category.name}
                    </button>
                    </li>
                ))}
                </ul>

                <div className="tabcontent row">
                    {/* 左側形象圖（可留白或之後放宣傳圖） */}
                    {/* <div className="col-12 col-lg-3 newc d-none d-lg-block"> */}
                        {/* 預留：若之後要顯示不同分類的形象圖，可取消註解 */}
                        {/* <img
                            src={currentImageId ? `/homeImg/news${currentImageId}.png` : "/homeImg/news1.png`}
                            alt="News"
                            loading="lazy"
                            className="img-fluid"
                        /> */}
                    {/* </div> */}

                    {/* 卡片區 */}
                    <div className="col-12">
                        {currentNews.length === 0 ? (
                            <div className="text-muted py-5 text-center">目前沒有資料</div>
                        ) : (
                            <div className="row g-4">
                                {currentNews.map((item, index) => {
                                    const key = `${index}-${item.art_id || item.new_id || "k" + index}`;
                                    const cover =
                                        item.cover_1 && item.cover_1.length > 0
                                            ? item.cover_1
                                            : "/images/400.png";
                                    const dateText = formatDate(item.create_date);
                                    const link = item.link ? item.link : `/home/newdetail/${item.new_id}`;
                                    const isExternal = Boolean(item.link);

                                    const CardInner = (
                                        <div className="newbox h-100">
                                            <div className="newbox-imgwrap">
                                                <img src={cover} alt={item.title} />
                                            </div>
                                            <div className="newmain">
                                                <h2 className="line-2">{item.title}</h2>
                                                {dateText && <span className="newdate">{dateText}</span>}
                                                {item.intro && < p className="line-2" dangerouslySetInnerHTML={{ __html: item.intro || "" }}/>}
                                                <span className="lm">MORE</span>
                                            </div>
                                        </div>
                                    );

                                    return (
                                        <div className="col-12 col-md-6 col-xl-4" key={key}>
                                            {isExternal ? (
                                                <a
                                                    href={link}
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                    className="text-decoration-none text-reset d-block h-100"
                                                >
                                                    {CardInner}
                                                </a>
                                            ) : (
                                                <Link
                                                    to={link}
                                                    className="text-decoration-none text-reset d-block h-100"
                                                >
                                                    {CardInner}
                                                </Link>
                                            )}
                                        </div>
                                    );
                                })}
                            </div>
                        )}
                    </div>
                </div>

                {/* 分頁 */}
                <div className="pagination mb100 mt-4 d-flex flex-wrap gap-2">
                    {getPageNumbersToShow().map((number) => (
                        <button
                            className={`page-link ${currentPage === number ? "active" : ""}`}
                            key={number}
                            onClick={() => setCurrentPage(number)}
                        >
                            {number}
                        </button>
                    ))}
                </div>
            </div>
        </div>
    );
}

export default Newsarea;
